import { formatCurrency, formatWithThousandsSeparator } from "./formatters";

export const errors = {
  requiredField: () => "Dieses Feld darf nicht leer sein.",
  requiredSelection: () => "Bitte treffen Sie eine Auswahl.",
  maxLengthDigits: (amount: number) => `Bitte geben Sie max. ${amount} Ziffern ein.`,
  minLengthCharacters: (amount: number) => `Bitte geben Sie min. ${amount} Zeichen ein.`,
  maxLengthCharacters: (amount: number) => `Bitte geben Sie max. ${amount} Zeichen ein.`,
  isPositive: () => "Bitte geben Sie einen positiven Wert ein.",
  isEmailCorrect: () => "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  isUserExist: () =>
    "Ihre E-Mail-Adresse oder Ihr Passwort sind nicht korrekt. Bitte überprüfen Sie Ihre Eingabe.",
  investmentCostUpperBound: () => "Eigenmittel > Investitionsbetrag.",
  isPercentage: () => "Bitte geben Sie einen gültigen Prozentwert ein.",
  isZipCode: () => "Bitte geben Sie eine gültige PLZ ein.",
  isPassword: () =>
    "Bitte geben Sie ein min. 8-stelliges Passwort an. Es muss min. eine Zahl und einen Groß- sowie einen Kleinbuchstaben enthalten.",
  isPasswordExtended: () =>
    "Bitte geben Sie ein min. 12-stelliges Passwort an. Es muss min. eine Zahl, ein Sonderzeichen und einen Groß- sowie einen Kleinbuchstaben enthalten.",
  invalidPassword: () => "Das Passwort stimmt nicht mit Ihrem vorherigen Passwort überein.",
  isAlreadyUsedPassword: () =>
    "Das von Ihnen eingegebene Passwort wurde bereits verwendet. Bitte wählen Sie ein anderes Passwort.",
  passwordMatch: () => "Die Passwörter stimmen nicht überein.",
  upperBoundVehicleCount: (amount: number) => `Es müssen weniger als ${amount} Fahrzeuge sein.`,
  isFutureDate: () => "Datum muss in der Zukunft liegen.",
  isPhoneNumberCorrect: () => "Bitte geben Sie die Telefonnummer startend mit +49 ein.",
  isPhoneNumberCorrectNew: () => "Bitte geben Sie eine gültige Telefonnummer im Format +49… ein.",
  isHoliday: () => "Das ausgewählte Datum ist ein Feiertag.",
  lowerBoundIncluded: (amount: number) => `Wert muss größer oder gleich ${amount} sein.`,
  upperBoundIncluded: (amount: number) => `Wert muss kleiner oder gleich ${amount} sein.`,
  lowerBound: (amount: number) => `Wert muss größer als ${amount} sein.`,
  upperBound: (amount: number) => `Wert muss kleiner als ${amount} sein.`,
  withLastName: () => "Bitte geben Sie auch den Nachnamen an.",
  withFirstName: () => "Bitte geben Sie auch den Vorname an.",
  minimumAmount: (amount: number) =>
    `Der Investitionsbetrag darf nicht kleiner als ${formatCurrency(amount)} sein.`,
  maximumAmount: (amount: number) =>
    `Der Investitionsbetrag darf nicht höher als ${formatCurrency(amount)} sein.`,
  maximumCountOfEmployees: (amount: number) =>
    `Bitte geben Sie einen Wert von maximal ${formatWithThousandsSeparator(amount)} ein.`,
  excludedStates: {
    brandenburg: () => "Bitte wenden Sie sich mit Ihrem Anliegen an (0331) 64 96 30.",
    sachsen: () => "Bitte wenden Sie sich mit Ihrem Anliegen an info@bbs-sachsen.de",
    bayern: () =>
      "Bitte wenden Sie sich mit Ihrem Anliegen an (089) 54 58 57 0 oder info@bb-bayern.de",
    thüringen: () =>
      "Bitte wenden Sie sich mit Ihrem Anliegen an (0361) 21 35 17 0 oder info@bb-thueringen.de"
  },
  foundingDate: (maxYear: number) =>
    `Das Gründungsdatum muss zwischen dem 01.01.1900 und 31.12.${maxYear} liegen`,
  durationBetween: (min: number, max: number) =>
    `Bitte geben Sie eine Laufzeit zwischen ${min} und ${max} Monaten an.`,
  interestFreeMonthsBetween: (min: number, max: number) =>
    `Bitte geben Sie zwischen ${min} und ${max} Freimonate an.`
};
